import { isMasurenPortal } from '~/utils/isMasurenPortal'

export function shouldLoadAdSenseScript (pagetype: string, path: string, portal?: string | null): boolean {
  if (isMasurenPortal(portal)) {
    return false
  }

  if (pagetype !== 'ContentPageType') {
    return false
  }

  if (path === '/' || path === '') {
    return false
  }

  if (path === '/vermieter/magazin' || path.startsWith('/vermieter/magazin/')) {
    return false
  }

  return true
}
